import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ItemGalleryForm from './ItemGalleryForm';
import Gallery from './Gallery';
import Button from '../atoms/Button';
import { getItemGalleryData } from '../../data/helper';
import { LexoRank } from 'lexorank';

interface ItemGalleryProps {
  venueID?: string;
  serviceProviderID?: string;
  data: any;
  access?: boolean;
}

const ItemGallery = (props: ItemGalleryProps) => {
  const { t } = useTranslation(['common']);
  const [edit, setEdit] = useState(false);
  const { venueID, serviceProviderID, data, access } = props;
  const gallery = getItemGalleryData(data, access);
  const gallerySorted = gallery.sort((a: any, b: any) => {
    return LexoRank.parse(a.lexorank).compareTo(LexoRank.parse(b.lexorank));
  });

  return (
    <>
      {edit ? (
        <>
          <ItemGalleryForm
            venueID={venueID}
            serviceProviderID={serviceProviderID}
            prefill={{ images: gallerySorted, logo: data.logo }}
            onSubmit={() => setEdit(false)}
            onCancel={() => setEdit(false)}
          />
          <br />
          <br />
        </>
      ) : (
        <>
          <Row>
            {/* Gallery */}
            {(!!gallery.length || access) && (
              <Col xs={8}>
                <br />
                <br />
                {/* <Gallery data={gallery} /> */}
                <Gallery
                  bg
                  data={gallery}
                  onEmptyClick={() => setEdit(true)}
                  showEmpty={
                    !gallery.length && access ? t(`common:no-images`) : ''
                  }
                />
              </Col>
            )}

            {!!access && (
              <Col xs={8}>
                <Button
                  small
                  dark
                  icon={'edit'}
                  label={t(`common:cta-edit`)}
                  onClick={() => setEdit(true)}
                />
                <br />
                <br />
              </Col>
            )}
          </Row>
        </>
      )}
    </>
  );
};

export default ItemGallery;
